/*--------------------------------------------------------------
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * See License.txt in the project root for license information.
 *--------------------------------------------------------------*/

/* eslint-disable no-duplicate-imports */
import { Node } from '@msdyn365-commerce-modules/utilities';
import * as React from 'react';

import { IOrderSummary } from '@msdyn365-commerce-modules/order-management';
import { IOrderConfirmationViewProps } from './absolute-salesdata';



export const OrderConfirmationOrderSummary: React.FC<IOrderSummary> = ({ orderSummaryProps, totalAmount }) => (
    <Node {...orderSummaryProps}>
        {totalAmount}
    </Node>
);




const OrderConfirmationView: React.FC<IOrderConfirmationViewProps> = ({
    
    
    orderSummary
}) => {
    return (
            
        <>{orderSummary && <OrderConfirmationOrderSummary {...orderSummary} />}</>
               
    );
};

export default OrderConfirmationView;
